import React from 'react';
import Avatar from 'react-avatar';
import moment from 'moment';
import {
 Image,
} from 'react-bootstrap';
import { Link } from 'react-router';
import TourDates from './TourDates';

class BookingRequestBadge extends React.Component {
  render() {
    let image = <Avatar name={this.props.request.tour.name} color="#326a34" size={250} />;
    if (this.props.request.tour.image) {
      image = <Image src={this.props.request.tour.image} responsive />;
    }
    let tourToday = '';
    if (moment().isBetween(this.props.request.tour.start, this.props.request.tour.end)) {
      // TODO: Find out which day of the tour
      tourToday = 'Ongoing';
    } else if (moment().isBefore(this.props.request.tour.start)) {
      tourToday = `Begins ${moment(this.props.request.tour.start).fromNow()}`;
    }
    return (
      <div className="col-sm-6 col-md-6 tour-container">
        <div className="tour">
          <Link to={`/booking/${this.props.request.id}`}>
            <div className="edit-overlay-container">
              <div className="background-test"></div>
              <div className="edit-overlay">
                <h3>Details</h3>
              </div>
            </div>
            <div className="tour-image">
              {image}
            </div>
            <div className="tour-name">
              <strong>{ this.props.request.tour.name }</strong><br />
              { this.props.request.tour.tag_line }<br />
            { this.props.request.brand && this.props.request.brand.name }
            </div>
          </Link>
          <div className="tour-dates">
            <TourDates
              start={this.props.request.tour.start}
              end={this.props.request.tour.end}
            />
          </div>

          <div className="tour-today text-center">
            {tourToday}
          </div>
        </div>
      </div>
    );
  }
}
export default BookingRequestBadge;



// WEBPACK FOOTER //
// src/routes/booking/components/BookingRequestBadge.js